import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import DeleteModal from 'components/deleteModalView';
import { useTranslation } from 'react-i18next';
import useCompanyCategory from '../useCompanyCategory';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const CompanyCategoriesMainPage = () => {
  const {
    columns,
    data,
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
  } = useCompanyCategory();
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  return (
    <div>
      <PageHeader title={'CATEGORIE INSEGNE'}>
        {pages?.ability?.can_create && (
          <Link to={'new'}>
            <Button width={'138px'} big icon={<PlusOutlined />}>
              {t('NUOVO')}
            </Button>
          </Link>
        )}
      </PageHeader>
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data.company_categories}
          pagination={data.pagination}
          loading={loading}
          onChange={onChangeTableFilter}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesMainPage;
